import BaseDataObject from './BaseDataObject';
import Money from './Money';
import ShoeInfo from './ShoeInfo';
import SulkyInfo from './SulkyInfo';

// GameInformation game update
export default class GameUpdate extends BaseDataObject {
  getTimestamp() {
    return this.getDate('timestamp');
  }

  getNumberOfLegUpdates() {
    return this.getNumberOf('legUpdates');
  }

  getLegUpdate(index) {
    return this.getObject('legUpdates', LegUpdate, index);
  }

  getTurnover() {
    return this.getObject('turnover', Money);
  }

  hasTurnover() {
    return this.has('turnover');
  }

  hasOdds() {
    return this.getBoolean('hasOdds');
  }

  hasDividendPerHorse() {
    return this.has('dividendPerHorse');
  }

  getDividendPerHorse() {
    return this.getObject('dividendPerHorse', BaseDataObject);
  }

  hasDividendPerHorsePerLeg() {
    return this.has('dividendPerHorsePerLeg');
  }

  getDividendPerHorsePerLeg() {
    return this.getObjects('dividendPerHorsePerLeg', BaseDataObject);
  }
}

class LegUpdate extends BaseDataObject {
  getLegNumber() {
    return this.getInteger('legNr');
  }

  getLegIndex() {
    return this.getLegNumber() - 1;
  }

  getNumberOfStartUpdates() {
    return this.getNumberOf('startUpdates');
  }

  getStartUpdate(index) {
    return this.getObject('startUpdates', StartUpdate, index);
  }

  getWinnerTurnover() {
    return this.getObject('turnoverVinnare', Money);
  }

  hasWinnerTurnover() {
    return this.has('turnoverVinnare');
  }
}

class StartUpdate extends BaseDataObject {
  getStartNumber() {
    return this.getInteger('startNumber');
  }

  getStartIndex() {
    return this.getStartNumber() - 1;
  }

  getMarkPercent() {
    return this.getFloat('markPercent');
  }

  hasMarkPercent() {
    return this.has('markPercent');
  }

  getOdds() {
    return this.getInteger('odds');
  }

  hasOdds() {
    return this.has('odds');
  }

  getTrioIndex() {
    return this.getInteger('trioIndex');
  }

  hasTrioIndex() {
    return this.has('trioIndex');
  }

  getScratched() {
    return this.getBoolean('scratched');
  }

  hasScratched() {
    return this.has('scratched');
  }

  getShoeInfo() {
    return this.getObject('shoeInfo', ShoeInfo);
  }

  hasShoeInfo() {
    return this.has('shoeInfo');
  }

  getSulkyInfo() {
    return this.getObject('sulkyInfo', SulkyInfo);
  }

  hasSulkyInfo() {
    return this.has('sulkyInfo');
  }

  isFirstStart() {
    return this.getBoolean('isFirstStart') === true;
  }
}
